export const responsiveImageSizes = {
  "sizes": {
    "desktop": { "width": 848 },
    "desktopSmall": { "width": 300 },
    "mobileLarge": { "width": 400 }
  },
  "carouselSizes": {
    "tabletLarge": { "width": 1280 },
    "tablet": { "width": 800 }
  }
};